<template>
  <v-card elevation="0" color="transparent">
    <v-row class="ma-3" :class="{'teal lighten-5': settingsUserFormFlag}">
      <v-col>
        <h3>
          Platform settings
          <v-btn icon small color="primary" @click="settingsUserFormFlag = !settingsUserFormFlag">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </h3>
        <v-simple-table class="mb-5">
          <tbody v-if="userData.settings">
          <tr>
            <td>Name</td>
            <td>{{userData.name}}</td>
          </tr>
          <tr>
            <td>Company Name</td>
            <td>{{userData.settings.completeName}}</td>
          </tr>
          <tr>
            <td>Company Name Short</td>
            <td>{{userData.settings.shortName}}</td>
          </tr>
          <tr>
            <td>Heading Logo</td>
            <td class="pa-2">
              <v-img :src="userData.settings.logo" max-width="150px"></v-img>
            </td>
          </tr>
          <tr>
            <td>Avatar logo</td>
            <td class="pa-2">
              <v-avatar>
                <v-img :src="userData.settings.shortLogo" max-width="50px"></v-img>
              </v-avatar>
            </td>
          </tr>
          <tr>
            <td>Branding
              <v-tooltip>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-on="on" v-bind="attrs">mdi-info</v-icon>
                </template>
                <span>This will mark with a red card each member of your staff that do not have your company as the main company in their linkedin badge</span>
              </v-tooltip>
            </td>
            <td>{{userData.settings.branding ? 'Yes' : 'No'}}</td>
          </tr>
          <tr>
            <td>Company urls</td>
            <td v-if="linkedinUrls">
              <span v-for="(url, key) in linkedinUrls" :key="key" class="d-block">{{url}}</span>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
      <v-col>

        <template v-if="settingsUserFormFlag">
          <h3>Edit platform settings</h3>
          <settings-user-form class="mt-6" :user-data="userData" :linkedinUrls="linkedinUrls"
                              @cancel="cancelListener"></settings-user-form>
        </template>

      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  import SettingsUserForm from "../Forms/settingsUserForm";
  export default {
    name: "editSettings",
    components: {SettingsUserForm},
    props: ['userData', 'linkedinUrls'],
    data: () => ({
      settingsUserFormFlag: false,
    }),
    methods: {
      cancelListener(event){
        this.settingsUserFormFlag = false;
        if (event.reload) {
          this.$emit('reload');
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Sections/editSettings.vue